import { useEffect, useState } from "react";
import axios from "axios";
import { useAuth } from "../../Auths/CheckUser.js";
import Swal from "sweetalert2";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClose } from "@fortawesome/free-solid-svg-icons";

const SewaClientList = () => {
  const { user } = useAuth();
  const [clients, setClients] = useState([]);
  const [selectedClient, setSelectedClient] = useState(null);

  useEffect(() => {
    if (!user) return;

    const fetchUser = async () => {
      try {
        const res = await axios.get(`https://globizsystems.click/api/user/${user.id}`);
        // console.log("Fetched user:", res.data);

        // Set clients safely
        setClients(Array.isArray(res.data.clients) ? res.data.clients : []);
      } catch (error) {
        console.error(error);
        Swal.fire("Error", "Failed to load user data", "error");
      }
    };

    fetchUser();
  }, [user]);

  const handleClientClick = (client) => {
    setSelectedClient(client);
  };

  const closePopup = () => {
    setSelectedClient(null);
  };

  return (
      <div className="mt-4">
        <h2 className="text-xl font-bold mb-4">Clients : {clients.length || 0}</h2>

        {clients.length === 0 ? (
          <p className="text-gray-500">No clients assigned.</p>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-4">
            {clients.map((client) => (
              <div
                key={client.id}
                onClick={() => handleClientClick(client)}
                className="p-4 border rounded-lg shadow-sm cursor-pointer hover:bg-gray-100"
              >
                <p className="font-semibold">
                  <span>{client.id}:</span> {client.name}
                </p>
                <p className="text-sm text-gray-600">Account No: {client.accountNumber}</p>
                <p className="text-sm text-gray-600">Status: {client.status}</p>
              </div>
            ))}
          </div>
        )}

        {/* Popup for client details */}
        {selectedClient && (
          <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 px-4">
            <div className="bg-white p-6 rounded-lg shadow-lg w-[450px] max-h-[90vh] overflow-y-auto">
              <div className="flex items-center justify-between">
              <h3 className="text-lg font-bold mb-3">{selectedClient.name}</h3>
              <button onClick={closePopup}> 
                <FontAwesomeIcon icon={faClose} />
              </button>
              </div>
              <div className="text-sm space-y-1">
                <p><strong>ID:</strong> {selectedClient.id}</p>
                <p><strong>KPI Type:</strong> {selectedClient.kpiType}</p>
                <p><strong>KPI:</strong> {selectedClient.kpi}</p>
                <p><strong>Zone ID:</strong> {selectedClient.zoneId}</p>
                <p><strong>Area ID:</strong> {selectedClient.areaId}</p>
                <p><strong>Rental Area:</strong> {selectedClient.rentalArea}</p>
                <p><strong>Rental Category:</strong> {selectedClient.rentalCategory}</p>
                <p><strong>Identification No:</strong> {selectedClient.identificationNumber}</p>
                <p><strong>Unit No:</strong> {selectedClient.unitNumber}</p>
                <p><strong>Property No:</strong> {selectedClient.propertyNumber}</p>
                <p><strong>Account No:</strong> {selectedClient.accountNumber}</p>
                <p><strong>Status:</strong> {selectedClient.status}</p>
                <p><strong>Aid Recipient:</strong> {selectedClient.aidRecipient}</p>
                <p><strong>Salary Deduction:</strong> {selectedClient.salaryDeduction}</p>
                <p><strong>Rental Rate:</strong> RM {selectedClient.rentalRate?.toLocaleString()}</p>
                <p><strong>Discount:</strong> RM {selectedClient.discount?.toLocaleString()}</p>
                <p><strong>Rental Charge:</strong> RM {selectedClient.rentalCharge?.toLocaleString()}</p>
                <p><strong>Arrears:</strong> RM {selectedClient.arrears?.toLocaleString()}</p>
                <p><strong>Payment:</strong> RM {selectedClient.payment?.toLocaleString()}</p>
                <p><strong>Created At:</strong> {new Date(selectedClient.createdAt).toLocaleString()}</p>
                <p><strong>Updated At:</strong> {new Date(selectedClient.updatedAt).toLocaleString()}</p>
              </div>

            </div>
          </div>
        )}
      </div>
  );
};

export default SewaClientList;
